<template>
	<div class="rechargeAmount mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">充值金额管理</div>
		</div>
		<div class="mainBot disBetween">
			<div class="contentLeft">
				<!-- 社区板块 -->
				<activityManage ref="activityManage"  @moduleZero="moduleZero"></activityManage>
			</div>
			<div class="contentRight">
				<!-- 充电站板块 -->
				<standardDispose ref="standardDispose" :disposeList="disposeList"></standardDispose>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import activityManage from "./activityManage/activityManage.vue"
	import standardDispose from "./standardDispose/standardDispose.vue"
	export default {
		name: "rechargeAmount",
		components: {
			activityManage,
			standardDispose,
		},
		data() {
			return {
				disposeList: [],
			}
		},
		mounted() {
		},
		methods: {
			moduleZero(arr){
				this.$set(this,"disposeList",arr)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./rechargeAmount.scss";
</style>
